import React from "react";
import { NavLink } from "react-router-dom"; // Importation de NavLink
import fleche_droit from "../../assets/img/icone_fleche_bleu_droite.png";
import doc from "../../assets/img/icone_diplome.png";

export default function Admission({ item }) {
  return (
    <div
      className="col-12 col-sm-12 bg-white col-md-12 col-lg-4 bordere-top my-2 my-md-0 mx-2 mx-lg-0    shadow-lg m-0 px-3 py-4 shadow-sm d-flex flex-column"
      style={{ minHeight: "300px" }}
    >
      {/* Icon */}
      <div
        className="d-flex d-block d-md-none justify-content-center mb-4 m-auto align-items-center rounded-circle"
        style={{
          width: "100%",
          height: "200px",
        }}
      >
        <img
          loading="lazy"
          src={item.img}
          alt="Document Icon"
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      {/* Icon */}
      <div
        className="d-flex  justify-content-center mb-4 m-auto align-items-center rounded-circle  d-none d-md-block"
        style={{
          width: "80px",
          height: "80px",
          backgroundColor: "#e3f2fd",
        }}
      >
        <img
          loading="lazy"
          src={doc}
          alt="Document Icon"
          style={{ width: "50px", height: "50px" }}
          className="m-auto d-flex  justify-content-center align-items-center mt-2"
        />
      </div>

      {/* Title */}
      <h5 className="fs-6 custom-titre-h1 fw-bold mb-2 text-left">
        {item.titre}
      </h5>

      <div className="mt-auto"></div>

      {/* NavLink (remplaçant du bouton) */}
      <div className="d-flex justify-content-left my-2">
        <NavLink
          to={item.page} // Lien de destination pour la navigation
          className="bg-b text-white px-3 py-1 rounded-4 border-0 d-flex align-items-center"
          style={{ fontSize: "12px", textDecoration: "none" }} // Appliquer le style
        >
          <span
            style={{ fontSize: "12px" }}
            className="d-flex align-items-center"
          >
            EN SAVOIR PLUS
            <img
              loading="lazy"
              src={fleche_droit}
              width={20}
              height={20}
              className="ms-2"
            />
          </span>
        </NavLink>
      </div>
    </div>
  );
}
